import {useParams} from "react-router-dom";
import {ManagerAccessLevelService} from "../../serverService/managerAccessLevelService/ManagerAccessLevelService";
import React, {useEffect, useState} from "react";
import {Helmet} from "react-helmet";
import {RouteInfo} from "../../route/RouteHelper";
import {css} from "@emotion/css";
import {prepareRaikoSelectBoxItem, RaikoSelectBox} from "../../raikoComponents/raikoSelectBox/RaikoSelectBox";
import {SnackbarHelper} from "../../util/SnackbarHelper";
import {useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {ServerErrorHandler} from "../../service/errorHandler/ServerErrorHandler";

import {
    RaikoDivider,
    RaikoMultiSelectTable,
    RaikoLabel,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb, raikoBreadCrumbItemGenerator,
    RaikoGridOneColumn,
    RaikoGridTwoColumn, RaikoSectionContainer, RaikoSimpleInputOutlined
} from "@moeindal/base-raiko-panel-components";
import {LoadingHelper} from "../../util/LoadingHelper";

export default function ManagerAccessLevelDetails() {

    let page = 0;
    const size = 50;

    const {id: accessLevelDetailId = -1} = useParams()

    const service = new ManagerAccessLevelService()
    const snackbar = new SnackbarHelper(useSnackbarDispatcher())
    const loading = new LoadingHelper(useLoadingDispatcher())

    const [accessLevelInfo, setAccessLevelInfo] = useState()
    const [title, setTitle] = useState("");
    const [name, setName] = useState("");

    const [permissionsList, setPermissionsList] = useState([]);

    const [permissionsFilters, setPermissionsFilters] = useState([]);
    const [permissionFilterLoading, setPermissionFilterLoading] = useState(false);
    const [selectedFilterItemId, setSelectedFilterItemId] = useState(-1);

    const [pageCount, setPageCount] = useState(0);
    const [accessList, setAccessList] = useState([]);
    const [accessSelectedItems, setAccessSelectedItems] = useState([]);
    const [accessTableLoadingState, setAccessTableLoadingState] = useState(false);


    useEffect(() => {
        if (typeof accessLevelDetailId !== 'undefined') {
            getDataFromServer()
            getFilter()
            getPermissions()
        }
    }, [accessLevelDetailId]);

    function getDataFromServer() {
        service.getRoleInfo(accessLevelDetailId)
            .then(response => {
                const permissions = []
                response.permissions.map((item) => {
                    permissions.push({
                        id: item.id,
                        name: item.title
                    })
                })
                setAccessSelectedItems(permissions)


                setTitle(response.title)
                setName(response.name)
            }).catch(reason => {
            snackbar.showServerErrorMessage(reason)
        }).finally(_ => {

        })
    }

    function getFilter() {
        setPermissionFilterLoading(true)
        service.getAccessFilters()
            .then(response => {
                setPermissionsFilters([
                    prepareRaikoSelectBoxItem(-1, "همــه", "ic-access-level")
                ])
                response.map((item, index) => {
                    setPermissionsFilters(prevState => [
                        ...prevState,
                        prepareRaikoSelectBoxItem(item.tagName, item.tagTitle, "ic-access-level")
                    ])
                })

                if (permissionsFilters && permissionsFilters.length > 0)
                    setSelectedFilterItemId(permissionsFilters[0].id)

            }).catch(reason => {
            snackbar.showServerErrorMessage(reason)
        }).finally(_ => {
            setPermissionFilterLoading(false)
        })

    }

    function getPermissions(tagFilter = selectedFilterItemId) {
        setAccessTableLoadingState(true)

        service.getPermissionsList(page, size, tagFilter !== -1 ? tagFilter : null)
            .then(response => {

                const _list = []
                response.data.map((item, index) => {
                    _list.push(
                        prepareRoleListRow(
                            (page * size) + index + 1,
                            item.id,
                            item.title,
                            item.tagTitle
                        )
                    )
                })

                setAccessList(_list)
                setPageCount(response.totalPage)

            }).catch(reason => {
            snackbar.showServerErrorMessage(reason)
        }).finally(_ => {
            setAccessTableLoadingState(false)
        })
    }

    function prepareRoleListRow(number, id, name, tagTitle) {
        return {
            number,
            id,
            name,
            tagTitle
        }
    }


    function handleUpdateBaseInfo() {
        if (checkFields()) {
            loading.show()

            service.updateRoleInfo(
                accessLevelDetailId,
                name,
                title,
                accessSelectedItems
            ).then(response => {
                snackbar.showSuccessMessage("بروزرسانی با موفقیت انجام شد!")
            }).catch(reason => {
                snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage())
            }).finally(_ => {
                loading.hide()
            })

        }
    }

    function checkFields() {
        let state = false
        let message = ""

        if (title.length === 0) {
            message = "لطفا نام دسترسی را وارد نمایید!"
        } else if (name.length === 0) {
            message = "لطفا slug را وارد نمایید!"
        } else if (accessSelectedItems.length === 0) {
            message = "لطفا دسترسی های مورد نظر را انتخاب نمایید!"
        } else {
            state = true
        }

        snackbar.showErrorMessage(message)

        return state


    }

    function handleFilterPermissions(id) {
        setSelectedFilterItemId(id)
        getPermissions(id)
    }


    function handleChangePagination(newPage) {
        page = newPage;
        getPermissions()
    }

    return (
        <>
            <Helmet>
                <title className="">{RouteInfo.Profile.name}</title>
            </Helmet>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem`}>

                    <RaikoBreadcrumb breadCrumbItems={[
                        raikoBreadCrumbItemGenerator(
                            "مدیریت",
                            ""
                        ),
                        raikoBreadCrumbItemGenerator(
                            RouteInfo.ManagersAccess.name,
                            RouteInfo.ManagersAccess.globalUrl),
                        raikoBreadCrumbItemGenerator(
                            title ? title : name,
                            ""),
                    ]}/>

                    <RaikoGridOneColumn>
                        <div
                            className={css`
                                display: flex;
                                justify-content: space-between;
                                align-items: center;
                                gap: .5rem;`}>
                            <RaikoLabel text={"فیلتر ها"}/>
                        </div>
                        <RaikoSelectBox
                            changeSelectItem={handleFilterPermissions}
                            items={permissionsFilters}
                            loading={permissionFilterLoading}
                            defaultSelectedItem={selectedFilterItemId}
                        />
                    </RaikoGridOneColumn>

                    <RaikoBaseCardContainer>
                        <RaikoGridOneColumn>
                            <RaikoSectionContainer
                                title={"اطلاعات پایه"}
                                hasActionButton
                                actionButtonOnclick={handleUpdateBaseInfo}
                            >
                                <RaikoGridOneColumn className={css`gap: 2rem`}>

                                    <RaikoGridTwoColumn>
                                        <RaikoSimpleInputOutlined labelText={"نام"} setValue={setTitle} value={title}/>
                                        <RaikoSimpleInputOutlined labelText={"Slug"} setValue={setName} value={name}/>
                                    </RaikoGridTwoColumn>

                                    <RaikoGridOneColumn className={css`gap: .75rem`}>
                                        <RaikoDivider/>
                                        <RaikoLabel text={"دسترسی ها"} className={css`font-weight: 900;
                                            font-family: iranYekanBold, sans-serif`}/>
                                        <RaikoDivider/>
                                        <RaikoMultiSelectTable
                                            pageCount={pageCount}
                                            setSelectedItems={setAccessSelectedItems}
                                            handleChangePagination={handleChangePagination}
                                            tableData={accessList}
                                            selectedItems={accessSelectedItems}
                                            tableHeader={accessTableHeader}
                                            tableLoadingState={accessTableLoadingState}
                                            reverseColumn={true}
                                        />
                                    </RaikoGridOneColumn>


                                </RaikoGridOneColumn>

                            </RaikoSectionContainer>

                        </RaikoGridOneColumn>
                    </RaikoBaseCardContainer>
                </RaikoGridOneColumn>

            </RaikoBaseContainer>
        </>
    )
}


const accessTableHeader = [
    {
        id: "number",
        label: "#"
    },
    {
        id: "name",
        label: "عنوان"
    },
    {
        id: "tagTitle",
        label: "دسته بندی"
    }
]
